import { useQuery } from '@tanstack/react-query'
import { useCurrentOrgId } from '@/stores/authStore'

import {
  zodExclusionWordResponseValidator,
  zodOrganizationResponseValidator,
  type ExclusionWordResponse,
  type OrganizationResponse,
} from './types/Organization'
import request from './request'

/* ---------------------------- Organization Details ---------------------------- */

const getOrganizationDetails = async () => {
  const res = await request<OrganizationResponse>({
    endpoint: '/organization/details',
    method: 'GET'
  })
  if (res.success) zodOrganizationResponseValidator(res.data)
  return res
}

export const useGetOrganizationDetails = () => {
  const currOrgId = useCurrentOrgId()
  return useQuery({
    queryKey: [currOrgId, 'organization', 'details'],
    queryFn: getOrganizationDetails
  })
}

export const updateOrganization = async (body: any) => {
  return request<any>({
    endpoint: '/organization/details',
    method: 'POST',
    body,
    multipart: true,
  })
}

/* ---------------------------- Organization Exclusion Words ---------------------------- */

const getOrganizationExclusionWords = async () => {
  const res = await request<{ exclusionWords: ExclusionWordResponse[] }>({
    endpoint: '/organization/exclusion-words',
    method: 'GET'
  })
  if (res.success) zodExclusionWordResponseValidator(res.data.exclusionWords)
  return res
}

export const useGetOrganizationExclusionWords = () => {
  const currOrgId = useCurrentOrgId()
  return useQuery({
    queryKey: [currOrgId, 'organization', 'exclusion-words'],
    queryFn: getOrganizationExclusionWords
  })
}

export const createOrganizationExclusionWord = async (body: { word: string }) => {
  return request<any>({
    endpoint: '/organization/exclusion-words',
    method: 'POST',
    body,
  })
}

export const deleteOrganizationExclusionWord = async (wordId: string) => {
  return request<any>({
    endpoint: `/organization/exclusion-words/${wordId}`,
    method: 'DELETE',
  })
}
